import { isMobile as isMobileLib } from "is-mobile";

export function isMobileUA(ua?: string): boolean {
  if (typeof window === "undefined") {
    return false;
  }

  return isMobileLib({ ua, tablet: true, featureDetect: true });
}
